import { css } from 'styled-components';
import { getThemeData } from '@hzero-front-ui/core';
var RangeStyle = function RangeStyle(props) {
  var _getThemeData = getThemeData(props, 'common'),
    primary = _getThemeData.primary,
    primary5 = _getThemeData.primary5;
  return css([".c7n-pro-range-wrapper{.c7n-pro-range-track{background:", ";}.c7n-pro-range:hover .c7n-pro-range-track{background:", ";}.c7n-pro-range-handle.c7n-pro-range-handle{border-color:", ";:focus{box-shadow:0 0 0 0.05rem #abcaff;}}.c7n-pro-range-step .c7n-pro-range-dot-active{border-color:", ";}}.c7n-pro-range.c7n-pro-range{:hover,:focus{.c7n-pro-range-handle.c7n-pro-range-handle{border-color:", ";}}}"], primary, primary5, primary, primary, primary);
};
export default RangeStyle;